import common from './slfuntapVgmTheme/commonStyle.oci';

import landscape from './slfuntapVgmTheme/landscape.oci';
import portrait from './slfuntapVgmTheme/portrait.oci';

export let commonStyles = common;
export let landscapeStyle = landscape;
export let portraitStyles = portrait;
